/**
 * Слой диалога — это и само окно, и его затемнение.
 *
 * Панели, которые живут ПОД диалогом и закрываются по клику снаружи (дровер референсов,
 * курсор Библиотеки), отличают «клик внутри модалки» от «клика мимо» по DOM: портал Radix
 * лежит вне их поддерева, и без явной проверки первый же клик в модалке схлопывал бы панель.
 *
 * У окна для этого есть role, а у Radix Overlay — нет: это голый div с одним data-state.
 * Поэтому затемнение помечаем сами, иначе клик по нему читается как «мимо всех диалогов»
 * и закрывает панель под модалкой (например, при закрытии просмотрщика ассета по backdrop).
 */
export const DIALOG_OVERLAY_ATTR = "data-dialog-overlay"

/** Пропсы затемнения: общие шасси диалогов раскрывают их в свой Dialog.Overlay. */
export const dialogOverlayProps = { [DIALOG_OVERLAY_ATTR]: "" } as const

/** Только окно диалога, без затемнения: «что сейчас перекрывает страницу». */
export const DIALOG_WINDOW_SELECTOR = '[role="dialog"],[role="alertdialog"]'

/** Canvas 3D-сцены живёт в portal на body, вне Dialog.Content. */
export const SCENE_3D_STAGE_ATTR = "data-scene-3d-stage"

/**
 * Anchored ReferencePicker, portaled above the 3D stage (also on body).
 * Must be treated as dialog-layer so WorkspaceDialog does not dismiss on pick clicks.
 */
export const SCENE_3D_PICKER_ATTR = "data-scene-3d-picker"

/** Toolbar dropdowns (speed etc.) portaled to body above the 3D stage. */
export const SCENE_3D_TOOLBAR_MENU_ATTR = "data-scene-3d-toolbar-menu"

export const DIALOG_LAYER_SELECTOR = `${DIALOG_WINDOW_SELECTOR},[${DIALOG_OVERLAY_ATTR}],[${SCENE_3D_STAGE_ATTR}],[${SCENE_3D_PICKER_ATTR}],[${SCENE_3D_TOOLBAR_MENU_ATTR}]`

/** Пришёлся ли клик на любой слой диалога — окно или его затемнение. */
export function insideDialogLayer(target: Element): boolean {
  return target.closest(DIALOG_LAYER_SELECTOR) != null
}

/** Открытое окно перекрывает страницу. Закрытый Radix `Content` (`data-state="closed"`) не считается. */
export function hasOpenDialogWindow(): boolean {
  return Array.from(document.querySelectorAll(DIALOG_WINDOW_SELECTOR)).some((el) => {
    const state = el.getAttribute("data-state")
    if (state === "closed") return false
    return true
  })
}
